import { NumberField } from '@/components/form/fields/text/NumberInput';
import DaasTableRowCell from '@/components/table/DaasTableRowCell';
import EllipsizedWithTooltip from '@/components/tooltip/EllipsizedWithTooltip';
import { useProduct } from '@/services/api/hooks/product';
import { FunctionComponent } from 'react';
import { StockTableData } from '../stockLevel.types';
import { StockLevelProductImage } from '../StockLevelProductImage';

interface Props {
  data: StockTableData;
  index: number;
  readonly?: boolean;
  onReservedStockChange: () => void;
}

export const SummaryStockLevelRow: FunctionComponent<Props> = ({ data, index, readonly, onReservedStockChange }) => {
  const [product] = useProduct(data.productId);

  const specs = product.propertyBag.properties?.map(spec => spec.text).join(' / ');

  return (
    <>
      <DaasTableRowCell className="justify-start">
        <div className="flex flex-row space-x-5 w-full h-[100px] items-center">
          <div className="w-[150px] h-full flex items-center">
            <StockLevelProductImage product={product} />
          </div>
          <div className="flex-1">
            <p className="text-lg">{product.manufacturer.name}</p>
            <p className="text-2xl font-semibold">{product.name}</p>
            <EllipsizedWithTooltip
              // Calc is full viewport - LHP / total table fraction to get value of 1fr
              // Since device table row is 1fr
              className="max-w-[calc((100vw-25rem)/1.8)]"
              id={`${product.id}-specs`}
              elementText={specs}
              tooltipText={specs}
            />
          </div>
        </div>
      </DaasTableRowCell>
      <DaasTableRowCell>
        <div className="text-lg">{product.productId}</div>
      </DaasTableRowCell>
      <DaasTableRowCell>
        {readonly ? (
          <div className="text-2xl font-semibold">{data.inStock}</div>
        ) : (
          <div>
            <NumberField
              onChangeCallback={onReservedStockChange}
              id={`stockData.${index}.inStock`}
              min={0}
              className="mb-2"
            />
          </div>
        )}
      </DaasTableRowCell>
      <DaasTableRowCell>
        <div className="text-2xl font-semibold">{data.minStockLevel}</div>
      </DaasTableRowCell>
      <DaasTableRowCell>
        <div className="text-2xl font-semibold">{data.maxStockLevel}</div>
      </DaasTableRowCell>
    </>
  );
};
